<template>
    <div class="main main-padding tea-pro-deta">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                        <TabPane :label="proName+'（活跃数量）'" name="activeUserDetails"></TabPane>
                        <TabPane :label="proName+'（使用总数）'" name="userDetails"></TabPane>
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        :placeholder="placeholder"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <div class="table-wrapper-data" v-if="tabIndex==-1">
                    <Table :columns="proUseColumn" :data="proUseList"></Table>
                </div>
                <div class="table-wrapper-data" v-else>
                    <Table :columns="proUseDataColumn" :data="proUseDataList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {
        findSeedUserList, findSeedAllUserList, findScreenList, findAllScreenList, findProductList,
        findAllProductList, findAllHomeWorkUsageRateList, findHomeWorkUsageRateList
    } from "../../../../service/api.js";

    export default {
        name: "use-pro-rate-details",
        data () {
            return {
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,
                placeholder: '',//关键字
                proName: this.$route.query.proName,//产品参数
                schoolId: this.$route.query.schoolId,//学校id
                // timeKey: "201901",//月份
                timeKey: this.$route.query.timeKey,//月份
                tabsName: this.$route.query.tabsName,//tab参数
                startTime: this.$route.query.startTime,//主页面开始时间
                endTime: this.$route.query.endTime,//主页面结束时间
                proUseList: [],//用户使用产品详情集合
                proUseDataList: [],//用户使用产品总数详情集合
                proUseColumn: [],
                proUseDataColumn: [],
            }
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.startTime,
                        endDate: this.endTime
                    }
                });
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                if (tabsName == 'activeUserDetails') {
                    //获取活跃用户数使用产品详情数据
                    this.tabIndex = -1;
                    this.loadUserProData();
                } else if (tabsName == 'userDetails') {
                    //获取用户数使用产品总数的详情数据
                    this.tabIndex = 1;
                    this.loadUserProTotalData();
                }
            },
            /**
             * 获取活跃用户数使用产品详情数据
             */
            loadUserProData () {
                this.placeholder = "支持用户姓名关键字搜索";
                if (this.proName == '大屏使用数') {
                    //获取大屏使用数（活跃数量）
                    this.queryScreenList();
                    this.placeholder = "支持硬盘ID关键字搜索"
                } else if (this.proName == '作业使用数') {
                    //获取作业使用数（活跃数量）
                    this.queryHomeWorkRateList();
                } else if (this.proName == '种子用户使用数') {
                    //种子用户使用数（活跃数量）
                    this.querySeedUserList();
                } else {
                    //获取各产品使用数（活跃数量）
                    this.queryProductList();
                }
            },
            /**
             * 获取活跃用户数使用产品总数的详情数据
             */
            loadUserProTotalData () {
                this.placeholder = "支持用户姓名关键字搜索";
                if (this.proName == '大屏使用数') {
                    //获取大屏使用数（使用总数）
                    this.queryAllScreenList();
                    this.placeholder = "支持硬盘ID关键字搜索"
                } else if (this.proName == '作业使用数') {
                    //获取作业使用数（使用总数）
                    this.queryAllHomeWorkRateList();
                } else if (this.proName == '种子用户使用数') {
                    //获取种子用户使用数（使用总数）
                    this.querySeedAllUserList();
                } else {
                    //获取各产品使用数（使用总数）
                    this.queryAllProductList();
                }
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                if (this.tabIndex == -1) {
                    //获取活跃用户数使用产品详情数据
                    this.loadUserProData();
                } else if (this.tabIndex == 1) {
                    //显示教师使用各产品的次数详情，并获取数据
                    this.loadUserProTotalData();
                }
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                if (this.tabIndex == -1) {
                    //获取活跃用户数使用产品详情数据
                    this.loadUserProData();
                } else if (this.tabIndex == 1) {
                    //显示教师使用各产品的次数详情，并获取数据
                    this.loadUserProTotalData();
                }
            },
            /**
             *获取种子用户使用数（活跃数量）
             */
            async querySeedUserList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findSeedUserList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "用户姓名",
                                    key: "fullName",
                                    align: "center"
                                },
                                {title: "学科", key: "subName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                },
                                {title: "天数", key: "day", align: "center"}
                            ];
                            _this.proUseList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取种子用户使用数（使用总数）
             */
            async querySeedAllUserList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findSeedAllUserList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseDataColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "用户姓名",
                                    key: "fullName",
                                    align: "center"
                                },
                                {title: "学科", key: "subName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                },
                                {title: "天数", key: "day", align: "center"}
                            ];
                            _this.proUseDataList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取大屏使用数（活跃数量）
             */
            async queryScreenList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findScreenList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "班级名称",
                                    key: "className",
                                    align: "center"
                                },
                                {title: "硬盘ID", key: "disk_id", align: "center"}, {
                                    title: "mac",
                                    key: "mac",
                                    align: "center"
                                },
                                {title: "天数", key: "day", align: "center"}
                            ];
                            _this.proUseList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取大屏使用数（使用总数）
             */
            async queryAllScreenList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findAllScreenList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseDataColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "班级名称",
                                    key: "className",
                                    align: "center"
                                },
                                {title: "硬盘ID", key: "disk_id", align: "center"}, {
                                    title: "mac",
                                    key: "mac",
                                    align: "center"
                                },
                                {title: "天数", key: "day", align: "center"}
                            ];
                            _this.proUseDataList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取作业使用数（活跃数量）
             */
            async queryHomeWorkRateList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findHomeWorkUsageRateList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "用户姓名",
                                    key: "fullName",
                                    align: "center"
                                },
                                {title: "学科", key: "bankName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                },
                                {title: "创建时间", key: "create_time", align: "center"}, {
                                    title: "天数",
                                    key: "day",
                                    align: "center"
                                }
                            ];
                            _this.proUseList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取作业使用数（使用总数）
             */
            async queryAllHomeWorkRateList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findAllHomeWorkUsageRateList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseDataColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "用户姓名",
                                    key: "fullName",
                                    align: "center"
                                },
                                {title: "学科", key: "bankName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                },
                                {title: "份数", key: "day", align: "center"}
                            ];
                            _this.proUseDataList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取个产品使用数（活跃数量）
             */
            async queryProductList () {
                let _this = this;
                let productKey = 0;
                switch (_this.proName) {
                    case "移动授课助手使用数":
                        productKey = 2;
                        break;
                    case "备课使用数":
                        productKey = 3;
                        break;
                    case "PC使用数":
                        productKey = 4;
                        break;
                }
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    productKey: productKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findProductList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseColumn = [
                                {title: "序号", key: "rowNum", align: "center"}, {
                                    title: "用户姓名",
                                    key: "fullName",
                                    align: "center"
                                },
                                {title: "学科", key: "subName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                }, {
                                    title: "天数",
                                    key: "day",
                                    align: "center"
                                }
                            ];
                            _this.proUseList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取各产品使用数（使用总数）
             */
            async queryAllProductList () {
                let _this = this;
                let productKey = 0;
                switch (_this.proName) {
                    case "移动授课助手使用数":
                        productKey = 2;
                        break;
                    case "备课使用数":
                        productKey = 3;
                        break;
                    case "PC使用数":
                        productKey = 4;
                        break;
                }
                let params = {
                    schoolId: _this.schoolId,
                    timeKey: _this.timeKey,
                    productKey: productKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findAllProductList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.proUseDataColumn = [{title: "序号", key: "rowNum", align: "center"}, {
                                title: "用户姓名",
                                key: "fullName",
                                align: "center"
                            },
                                {title: "学科", key: "subName", align: "center"}, {
                                    title: "手机号码",
                                    key: "mobile",
                                    align: "center"
                                },
                                {title: "天数", key: "day", align: "center"}
                            ];
                            _this.proUseDataList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
        },
        mounted () {
            this.changeDataDetailsIndex(this.tabsName);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .tea-pro-deta {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
